import { Box, useMediaQuery, useTheme } from '@mui/material'
import { motion } from 'framer-motion'
import { SlideDefinition } from '../types'

type UnjudgeSlideProps = {
  isActive: boolean
  slide: SlideDefinition
}

const DEFAULT_IMAGE_SRC = '/hero_unjudge.png'
const DEFAULT_START_SCALE = 1
const DEFAULT_END_SCALE = 1.035
const MOBILE_PAN_DISTANCE_PX = 208

const UnjudgeSlide = ({ isActive, slide }: UnjudgeSlideProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const imageSrc =
    typeof slide.data?.imageSrc === 'string'
      ? slide.data.imageSrc
      : DEFAULT_IMAGE_SRC

  const initialAnimation = isMobile
    ? { x: 0, scale: DEFAULT_START_SCALE }
    : { scale: DEFAULT_START_SCALE }

  const activeAnimation = isMobile
    ? { x: -MOBILE_PAN_DISTANCE_PX, scale: DEFAULT_START_SCALE }
    : { scale: DEFAULT_END_SCALE }

  const inactiveAnimation = isMobile
    ? { x: 0, scale: DEFAULT_START_SCALE }
    : { scale: DEFAULT_START_SCALE }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        background: slide.background,
      }}
    >
      <motion.img
        src={imageSrc}
        alt="Unjudge Someone"
        initial={initialAnimation}
        animate={isActive ? activeAnimation : inactiveAnimation}
        transition={{
          duration: Math.max(slide.durationMs, 10000) / 1000,
          ease: 'easeOut',
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: isMobile ? `calc(100% + ${MOBILE_PAN_DISTANCE_PX}px)` : '100%',
          height: '100%',
          objectFit: 'cover',
          transformOrigin: 'center center',
          pointerEvents: 'none',
        }}
      />
    </Box>
  )
}

export default UnjudgeSlide
